export default __webpack_public_path__ + "static/media/Blog-1.134ed30d.png";